/* eslint-disable no-console -- this sink is the console adapter */
import type {LogAttributes, LogLevel, LogSink} from './types'

const toLine = (level: LogLevel, message: string, attributes: LogAttributes): string => {
  try {
    return JSON.stringify({...attributes, level, message})
  } catch {
    return JSON.stringify({level, message})
  }
}

export const consoleSink: LogSink = (level, message, attributes) => {
  console[level](toLine(level, message, attributes))
}
